// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"94":"fcd34cf1591f9d0352f9","354":"062e267e368cffd99264","540":"f91d503b05a195ae097b","780":"0fe12bf8c3c3176cb34f","828":"c0cb13683f964f321efe","838":"ba421f36f25c2306387b","961":"9ee94f05ed559983e971"}[chunkId] + ".chunk.js";
};